import { inject, observer } from 'mobx-react'
import { ReactComponent as RotateIcon } from '../../../svg/rotate.svg'
import { ReactComponent as MoveIcon } from '../../../svg/move.svg'
import React from 'react'

@inject('workAreaStore', 'layerStore') @observer
class LayerTools extends React.Component {

  toggleMouseClick(e, start = true){
    const { clientX, clientY } = e
    const { workAreaStore } = this.props
    if(start){
      workAreaStore.handleResizeMouseDown(clientX, clientY)
    }else{
      workAreaStore.handleResizeMouseUp()
    }
  }

  setActiveDot(type){
    this.props.workAreaStore.setActiveResizeDot(type)
  }

  setActiveResizeBar(type){
    this.props.workAreaStore.setActiveResizeBar(type)
  }

  render(){
    const { workAreaStore, layerStore, index } = this.props
    const page = workAreaStore.pages[index]
    const style = {
      ...layerStore.getPageStyle(page, true),
      top: index === 0 ? 0 : (page.displayHeight * index) + (20 * index)
    }
    const { zoom } = workAreaStore
    const z = zoom / 100
    const zoomValue = 2 - z
    const zv = zoom / 100
    let toolWrapperStyle = {
      height: `${30 / zv}px`,
      width: `${30 / zv}px`,
      bottom: `${-55 / zv}px`,
      left: `calc(50% - ${30 / zv}px)`
    }
    let iconStyle = {
      height: `${18 / zv}px`,
      width: `${18 / zv}px`,
    }
    if(zoomValue <= 0.65){
      toolWrapperStyle = {
        height: '20px',
        width: '20px',
        bottom: '-60px'
      }
      iconStyle = {
        height: '11px',
        width: '11px'
      }
    }
    let metaDataStyle = {
      height: `${15 / zv}px`,
      width: `${25 / zv}px`,
      left: `calc(50% - ${12.5 / zv}px)`,
      bottom: `${-20 / zv}px`,
    }
    const dotSize = 20 / (zoom / 100)
    const bgSize = 1 / z > 0.6 ? 1 / z : 0.6
    const bg = {
      backgroundSize: `12px ${bgSize}px, ${bgSize}px 12px, 12px ${bgSize}px, ${bgSize}px 12px`
    }
    const barDimensions = {
      f: 3 / (zoom / 100) + 'px',
      s: 25 / (zoom / 100) + 'px',
      sRaw: 25 / (zoom / 100),
      align: -3 / (zoom / 100) + 'px'
    }
    return (
      <div 
        className='workarea__layer-tools'
        style={style}
      >
        {
          page.layers.map(layer => {
            const { rotate: isRotating } = workAreaStore
            const { id, rotation, selected, type, originX, originY, xPos, yPos, photoType } = layer
            const layerStyle = this.props.workAreaStore.getLayerStyle(layer, true);
            const originPos = {}
            if(originX && originY){
              originPos.transformOrigin = `${originX} ${originY}`
            }
            return (
              <div key={id}>
                <div className='workarea__layer-outline-wrapper'>
                  {selected ? <div className='workarea__layer-outline'
                    style={
                      {
                        ...layerStyle,
                        transform: `translate(${type === 'svg' ? layer.boxX + xPos : xPos}px, 
                          ${type === 'svg' ? layer.boxY + yPos : yPos}px) ${layerStyle.transform ?
                          layerStyle.transform : ""}`,
                        ...bg,
                        ...originPos
                      }
                    }
                  >
                  </div> : <></>}
                </div>
                {
                  selected ?
                    <div 
                      className="workarea__layer-tools__toolbox " 
                      style={{
                        ...layerStyle,
                        transform: `translate(${type === 'svg' ? xPos + layer.boxX : xPos}px, 
                            ${type === 'svg' ? yPos + layer.boxY : yPos}px) ${layerStyle.transform ?
                            layerStyle.transform : ""}`,
                        ...originPos
                        }
                      }
                    >
                      {
                        type !== 'group' && !photoType && type !== 'svg' ? 
                        <>
                          <div className='workarea__layer-tools__toolbox__resize-bar left '
                            onMouseDown={() => this.setActiveResizeBar('left')}
                            style={{
                              width: barDimensions.f,
                              left: barDimensions.align,
                              height: barDimensions.s,
                              top: `calc(50% - ${barDimensions.sRaw / 2}px)`
                            }}
                          />
                          <div className='workarea__layer-tools__toolbox__resize-bar right '
                            onMouseDown={() => this.setActiveResizeBar('right')}
                            style={{
                              width: barDimensions.f,
                              right: barDimensions.align,
                              height: barDimensions.s,
                              top: `calc(50% - ${barDimensions.sRaw / 2}px)`
                            }}
                          />
                          {
                            type !== 'text' ? 
                            <>
                              <div className='workarea__layer-tools__toolbox__resize-bar top '
                                onMouseDown={() => this.setActiveResizeBar('top')}
                                style={{
                                  left: `calc(50% - ${barDimensions.sRaw / 2}px)`,
                                  height: barDimensions.f,
                                  top: barDimensions.align,
                                  width: barDimensions.s
                                }}
                              />
                              <div className='workarea__layer-tools__toolbox__resize-bar bottom '
                                onMouseDown={() => this.setActiveResizeBar('bottom')}
                                style={{
                                  left: `calc(50% - ${barDimensions.sRaw / 2}px)`,
                                  height: barDimensions.f,
                                  bottom: barDimensions.align,
                                  width: barDimensions.s
                                }}
                              />
                            </> 
                            : 
                            undefined
                          }
                        </>
                        :
                        undefined
                      }
                      <div
                        className={`workarea__layer-tools__toolbox__dot upper-left `}
                        style={{
                          width: dotSize + 'px',
                          height: dotSize + 'px',
                          left: -1 * (dotSize / 2),
                          top: -1 * (dotSize / 2)
                        }}
                        onMouseDown={() => this.setActiveDot('topLeft')}
                      />
                      <div 
                        className='workarea__layer-tools__toolbox__dot upper-right '
                        style={{
                          width: dotSize + 'px',
                          height: dotSize + 'px',
                          right: -1 * (dotSize / 2),
                          top: -1 * (dotSize / 2)
                        }}
                        onMouseDown={() => this.setActiveDot('topRight')}
                      />
                      <div 
                        className='workarea__layer-tools__toolbox__dot bottom-right '
                        style={{
                          width: dotSize + 'px',
                          height: dotSize + 'px',
                          right: -1 * (dotSize / 2),
                          bottom: -1 * (dotSize / 2)
                        }}
                        onMouseDown={() => this.setActiveDot('bottomRight')}
                      />
                      <div 
                        className='workarea__layer-tools__toolbox__dot bottom-left '
                        style={{
                          width: dotSize + 'px',
                          height: dotSize + 'px',
                          left: -1 * (dotSize / 2),
                          bottom: -1 * (dotSize / 2)
                        }}
                        onMouseDown={() => this.setActiveDot('bottomLeft')}
                      />
                      <div 
                        style={{...toolWrapperStyle, left: type !== 'text' ? `calc(50% - ${15 / zv}px)` : toolWrapperStyle.left}}
                        className={type === 'text' ? 'workarea__layer-tools__toolbox__rotate text' : 'workarea__layer-tools__toolbox__rotate'}>
                          <RotateIcon 
                            className="workarea__layer-tools__toolbox__rotate__icon"
                            style={iconStyle}  
                          />
                      </div>
                      {
                        type === 'text' ? 
                        (
                          <div 
                            style={{
                              ...toolWrapperStyle,
                              marginLeft: `${40 / zv}px`
                            }}
                            className='workarea__layer-tools__toolbox__move'>
                            <MoveIcon 
                              style={iconStyle}  
                              className='workarea__layer-tools__toolbox__move__icon' 
                            />
                          </div>
                        )
                        :
                        undefined
                      }
                      {
                        isRotating ? (
                          <div
                            style={{
                              ...metaDataStyle,
                              transform: `rotate(${-rotation}deg)`,
                            }} 
                            className='workarea__layer-tools__toolbox__layer-rotation'>
                            <span 
                              style={{
                                fontSize: `${12 / zv}px`
                              }}
                            >{rotation}°</span>
                          </div>
                        )
                        :
                        undefined
                      }
                    </div>
                  :
                  undefined
                }
              </div>
            )
          })
        }
      </div>
    )
  }

}

export default LayerTools